<script>
import CardCarcass from './CardCarcass.vue'

export default {
  name: 'Card',
  components: { CardCarcass },
  computed: {
    isMobileVersion() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    },
    cardClass() {
      return this.isMobileVersion ? '' : 'w-48'
    },
    flexDirectionClass() {
      return {
        'flex-row': !this.isMobileVersion,
        'flex-col': this.isMobileVersion,
      }
    },
  },
}
</script>

<template>
  <CardCarcass>
    <div class="flex" :class="flexDirectionClass">
      <div :class="cardClass">
        <slot name="right">(；一_一)</slot>
      </div>
      <div class="flex-1 pl-2 overflow-hidden">
        <slot name="left">( ﾟヮﾟ)</slot>
      </div>
    </div>
  </CardCarcass>
</template>
